import '../App.css';
import { useNavigate } from "react-router-dom";
import NavBar from './navbar';
import NavMenu from './navmenu';
import * as Quotes from '../slices/quotesSlice';
import * as Forms from '../slices/formsSlice';
import * as UI from '../slices/uiSlice';
import { useAppDispatch, useAppSelector } from '../slices/index';
import { handleScroll } from '../utilities';
import { AnyAction } from 'redux';
import hub_logo from '../assets/Main_Hub_Icon_Large.svg';
import main_hub_purple from '../assets/Main_Hub_Purple.svg';
import quote_purple from '../assets/Quote_Purple.svg';
import instruct_purple from '../assets/Instruct_Purple.svg';
import wishlist_purple from '../assets/Wishlist_Purple.svg';
import analytics_purple from '../assets/Analytics_Purple.svg';
import leading_the_way from '../assets/Leading_The_Way_Conveyancing.svg';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSync } from '@fortawesome/free-solid-svg-icons';

const Home = () => {
	const dispatch = useAppDispatch();
	const navigate = useNavigate();
	const userState = useAppSelector(state => state.user);
	const cases = useAppSelector(state => state.cases);
	const ui = useAppSelector(state => state.ui);

	const isLoaded = cases.isLoaded;

	const clickItem = (loc: string) => {
		const closeMenu = () => new Promise((resolve) => resolve(dispatch((UI.closeMenu()) as unknown as AnyAction)));
		if (loc == "/quote") {
			const removequoteform = () => new Promise((resolve) => resolve(dispatch((Forms.removeFormWithId("QF")) as unknown as AnyAction)));
			const removeinstructionform = () => new Promise((resolve) => resolve(dispatch((Forms.removeFormWithId("IF")) as unknown as AnyAction)));
			const selquote = () => new Promise((resolve) => resolve(dispatch((Quotes.selectQuote("")) as unknown as AnyAction)));
			closeMenu().then(() => removequoteform()).then(() => removeinstructionform()).then(() => selquote()).then(() => navigate('/quote'));
			return;
		}
		if (loc == "/instruct") {
			const removeinstructionform = () => new Promise((resolve) => resolve(dispatch((Forms.removeFormWithId("IF")) as unknown as AnyAction)));
			const selquote = () => new Promise((resolve) => resolve(dispatch((Quotes.selectQuote("")) as unknown as AnyAction)));
			closeMenu().then(() => removeinstructionform()).then(() => selquote()).then(() => navigate('/instruct'));
			return;
		}
		closeMenu().then(() => navigate(loc));
	}

	return (
		<div className="Home" style={{ position: 'relative' }}>
			<div style={{ position: 'absolute', top: 96, left: 0, right: 0, bottom: 80, overflowY: 'scroll' }} onScroll={handleScroll}>
				<div className='OrangeBand' style={{ paddingTop: 96 }}>
					<div style={{ marginLeft: '10%', marginRight: '10%', width: '80%', display: 'flex' }}>
						<img style={{ width: 192, marginRight: 8 }} src={hub_logo} alt='Hub-Logo' />
						<div style={{ marginLeft: 24 }}>
							<div style={{ fontFamily: 'OpenSans-Bold', fontSize: 36, marginBottom: 12 }}>Welcome to your Introducer Portal</div>
							<div style={{ fontFamily: 'OpenSans-SemiBold', fontSize: 20, marginBottom: 12 }}>As an award winning firm, we know how important a speedy and efficient service is to you and your customer. We also know that communication is key!</div>
							<div style={{ fontFamily: 'OpenSans-SemiBold', fontSize: 20 }}>This portal will allow you to view your active cases with PLS and enable you to take an active role in collaborating with us to ensure our mutual success.</div>
						</div>
					</div>
				</div>
				<div style={{ marginLeft: '10%', marginRight: '10%', width: '80%' }}>
					<div style={{ color: 'black', fontFamily: 'OpenSans-SemiBold', fontSize: 16, marginTop: 16 }}>Everything you do in this portal imports directly into our case workflow and the actions we take are fed back to you automatically into your portal account.</div>
					<div style={{ color: 'black', fontFamily: 'OpenSans-Regular', fontSize: 16, marginTop: 8 }}>Here you will be able to:</div>
					<div style={{ display: 'flex', flexWrap: 'wrap', alignItems: 'start', marginTop: 16 }}>
						<div style={{ width: '33%', marginTop: 12, marginBottom: 12, display: 'flex', alignItems: 'start' }}>
							{isLoaded && <div className={(isLoaded ? 'homeIcon homeIconHover' : 'homeIcon')} onClick={(isLoaded ? () => clickItem('/hub') : undefined)}>
								<img style={{ width: 96, height: 96 }} src={main_hub_purple} alt='MainHub-Icon' />
							</div>}
							{!isLoaded &&
								<div style={{ width: 96, height: 96, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
									<FontAwesomeIcon className='fa-spin' style={{ fontSize: 40, marginRight: 8, color: '513764' }} icon={faSync} />
								</div>
							}
							<div style={{ marginLeft: 8, marginRight: 8, color: 'black', fontFamily: 'OpenSans-Regular', fontSize: 14 }}>View all your active cases and track their progress. You can create actions for PLS to call, email and chase third parties and you will receive updates here. You can also ask PLS ‘Why we can’t…’ to find out what may be holding up the process.</div>
						</div>
						<div style={{ width: '33%', marginTop: 12, marginBottom: 12, display: 'flex', alignItems: 'start' }}>
							<div className='homeIcon homeIconHover' onClick={() => clickItem('/quote')}>
								<img style={{ width: 96, height: 96 }} src={quote_purple} alt='Quote-Icon' />
							</div>
							<div style={{ marginLeft: 8, marginRight: 8, color: 'black', fontFamily: 'OpenSans-Regular', fontSize: 14 }}>You can generate an instant quote to either instruct straight away or save for a later date.</div>
						</div>
						<div style={{ width: '33%', marginTop: 12, marginBottom: 12, display: 'flex', alignItems: 'start' }}>
							{isLoaded && <div className={(isLoaded ? 'homeIcon homeIconHover' : 'homeIcon')} onClick={(isLoaded ? () => clickItem('/loadquotes') : undefined)}>
								<img style={{ width: 96, height: 96 }} src={quote_purple} alt='Quote-Icon' />
							</div>}
							{!isLoaded &&
								<div style={{ width: 96, height: 96, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
									<FontAwesomeIcon className='fa-spin' style={{ fontSize: 40, marginRight: 8, color: '513764' }} icon={faSync} />
								</div>
							}
							<div style={{ marginLeft: 8, marginRight: 8, color: 'black', fontFamily: 'OpenSans-Regular', fontSize: 14 }}>You can view all the quotes you have saved and submitted. From here you can also instruct PLS with the click of a button.</div>
						</div>
						<div style={{ width: '33%', marginTop: 12, marginBottom: 12, display: 'flex', alignItems: 'start' }}>
							{isLoaded && <div className={(isLoaded ? 'homeIcon homeIconHover' : 'homeIcon')} onClick={(isLoaded ? () => clickItem('/instruct') : undefined)}>
								<img style={{ width: 96, height: 96 }} src={instruct_purple} alt='Instruct-Icon' />
							</div>}
							{!isLoaded &&
								<div style={{ width: 96, height: 96, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
									<FontAwesomeIcon className='fa-spin' style={{ fontSize: 40, marginRight: 8, color: '513764' }} icon={faSync} />
								</div>
							}
							<div style={{ marginLeft: 8, marginRight: 8, color: 'black', fontFamily: 'OpenSans-Regular', fontSize: 14 }}>You can instruct cases directly into our system. Your clients will then recieve their own portal account information within 2 hours - allowing them to get started as quickly as possible!</div>
						</div>
						<div style={{ width: '33%', marginTop: 12, marginBottom: 12, display: 'flex', alignItems: 'start' }}>
							{isLoaded && <div className={(isLoaded ? 'homeIcon homeIconHover' : 'homeIcon')} onClick={(isLoaded ? () => clickItem('/wishlist') : undefined)}>
								<img style={{ width: 96, height: 96 }} src={wishlist_purple} alt='Wishlist-Icon' />
							</div>}
							{!isLoaded &&
								<div style={{ width: 96, height: 96, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
									<FontAwesomeIcon className='fa-spin' style={{ fontSize: 40, marginRight: 8, color: '513764' }} icon={faSync} />
								</div>
							}
							<div style={{ marginLeft: 8, marginRight: 8, color: 'black', fontFamily: 'OpenSans-Regular', fontSize: 14 }}>You can pick your Wishlist. Wishlist cases are the highest priority for you. We will then expidite the activity on those matters!</div>
						</div>
						<div style={{ width: '33%', marginTop: 12, marginBottom: 12, display: 'flex', alignItems: 'start' }}>
							{isLoaded && <div className={(isLoaded ? 'homeIcon homeIconHover' : 'homeIcon')} onClick={(isLoaded ? () => clickItem('/analytics') : undefined)}>
								<img style={{ width: 96, height: 96 }} src={analytics_purple} alt='Analytics-Icon' />
							</div>}
							{!isLoaded &&
								<div style={{ width: 96, height: 96, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
									<FontAwesomeIcon className='fa-spin' style={{ fontSize: 40, marginRight: 8, color: '513764' }} icon={faSync} />
								</div>
							}
							<div style={{ marginLeft: 8, marginRight: 8, color: 'black', fontFamily: 'OpenSans-Regular', fontSize: 14 }}>We know that targets are important, so here you can view the analytics and pull reports.</div>
						</div>
					</div>
				</div>
			</div>
			<div className='mainFooter'>
				<div style={{ marginLeft: '10%', marginRight: '10%', width: '80%', marginTop: 18 }}>
					<img style={{ height: 28 }} src={leading_the_way} alt='LeadingTheWay-Banner' />
				</div>
			</div>
			<div className='loginFooter'></div>
			<NavMenu />
			<NavBar />
		</div>
	);
}

export default Home;